import { SvgIcon } from "@mui/material";
import styles from "../shared.module.scss";
import { ReactComponent as Document } from "./document.svg";
import { ReactComponent as Remove } from "./remove.svg";
import { ReactComponent as Open } from "./open.svg";
import { ReactComponent as Edit } from "./edit.svg";

import { ReactComponent as Creation } from "./creation.svg";
import { ReactComponent as Modification } from "./modification.svg";
import { ReactComponent as Delete } from "./delete.svg";

export const DocumentIcon = () => <SvgIcon className={styles.customIcons} component={Document} inheritViewBox />;

export const RemoveIcon = () => <SvgIcon className={styles.customIcons} component={Remove} inheritViewBox />;

export const OpenIcon = () => (
  <SvgIcon className={`${styles.customIcons} ${styles.open}`} component={Open} inheritViewBox />
);

export const EditIcon = () => <SvgIcon className={styles.customIcons} component={Edit} inheritViewBox />;

export const CreationIcon = () => <SvgIcon className={styles.customIcons} component={Creation} inheritViewBox />;

export const ModificationIcon = () => (
  <SvgIcon className={styles.customIcons} component={Modification} inheritViewBox />
);

export const DeleteIcon = () => <SvgIcon className={styles.customIcons} component={Delete} inheritViewBox />;
